import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Space, Alert } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import axios from 'axios';

function Login({ onLogin }) {
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login');
  const [registrationStatus, setRegistrationStatus] = useState({
    registrationEnabled: false,
    inviteRequired: false,
  });

  React.useEffect(() => {
    axios.get('/api/chat/auth/registration')
      .then((response) => setRegistrationStatus(response.data))
      .catch(() => setRegistrationStatus({ registrationEnabled: false, inviteRequired: false }));
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const url = mode === 'login' ? '/api/chat/auth/login' : '/api/chat/auth/register';
      // 注册时用户名即邮箱，同一值同时作为登录账号与邮箱提交。
      const payload = mode === 'register' ? { ...values, email: values.username } : values;
      const response = await axios.post(url, payload, { withCredentials: true });
      if (response.data.success) {
        message.success(mode === 'login' ? '登录成功' : '注册成功');
        onLogin();
      }
    } catch (err) {
      message.error(err.response?.data?.error || (mode === 'login' ? '登录失败' : '注册失败'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5' }}>
      <Card
        title={mode === 'login' ? 'AI 对话登录' : 'AI 对话注册'}
        style={{ width: 400 }}
        extra={
          <Button type="link" onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>
            {mode === 'login' ? '注册' : '返回登录'}
          </Button>
        }
      >
        {mode === 'register' && !registrationStatus.registrationEnabled ? (
          <Alert type="warning" message="当前未开放注册" style={{ marginBottom: 16 }} />
        ) : null}
        <Form name={mode} onFinish={onFinish} autoComplete="off">
          <Form.Item
            name="username"
            rules={
              mode === 'register'
                ? [
                    { required: true, message: '请输入邮箱' },
                    { type: 'email', message: '请输入正确的邮箱格式' },
                  ]
                : [{ required: true, message: '请输入用户名' }]
            }
          >
            <Input
              prefix={mode === 'register' ? <MailOutlined /> : <UserOutlined />}
              placeholder={mode === 'register' ? '请输入邮箱（作为登录账号，请勿使用临时邮箱）' : '用户名'}
            />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          {mode === 'register' ? (
            <Form.Item name="displayName" rules={[{ required: true, message: '请输入显示名称' }]}>
              <Input prefix={<UserOutlined />} placeholder="显示名称" />
            </Form.Item>
          ) : null}
          {mode === 'register' && registrationStatus.inviteRequired ? (
            <Form.Item name="invitationCode" rules={[{ required: true, message: '请输入邀请码' }]}>
              <Input placeholder="邀请码" />
            </Form.Item>
          ) : null}
          <Form.Item>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={mode === 'register' && !registrationStatus.registrationEnabled}
                block
              >
                {mode === 'login' ? '登录' : '注册'}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default Login;
